import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import { userCan } from '../../helpers/Auth';
import {
  getFileAccessIcon,
  getFileAccessText,
  isEditionInWorkspace,
} from '../../helpers/Files';
import { getSetting } from '../../helpers/Settings';

const FileAccess = ({
  file,
  handleChangeAccess,
  callbackUpdate,
  alias,
}) => {
  const intl = useIntl();

  return (
    <span className="file-access">
      {(!file.deleted_at && userCan('file.change_access', file)) ? (
        <a
          href="#file-access-settings"
          onClick={(e) => {
            e.preventDefault();
            handleChangeAccess(file, callbackUpdate);
          }}
          aria-label={intl.formatMessage({ defaultMessage: 'Change access' })}
        >
          {!isEditionInWorkspace(file) ? (
            <span className="file-access-show-in-workspace">
              {intl.formatMessage({ defaultMessage: 'Show in workspace' })}
            </span>
          ) : (
            <i className={`fas ${getFileAccessIcon(file)}`} id={`FileAccessTooltip${alias}-${file.uuid}`} />
          )}
        </a>
      ) : (
        <span>
          <i className={`fas ${getFileAccessIcon(file)}`} id={`FileAccessTooltip${alias}-${file.uuid}`} />
        </span>
      )}
      {(!getSetting('cs1') && isEditionInWorkspace(file)) && (
        <UncontrolledTooltip fade={false} placement="bottom" target={`FileAccessTooltip${alias}-${file.uuid}`}>
          {getFileAccessText(file, intl)}
        </UncontrolledTooltip>
      )}
    </span>
  );
};

const mapDispatchToProps = dispatch => ({
  handleChangeAccess: (file, callbackUpdate) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      files: [file.uuid],
      callbackUpdate,
    }));
  },
});

FileAccess.defaultProps = {
  callbackUpdate: () => {},
  alias: '',
};

FileAccess.propTypes = {
  file: PropTypes.object.isRequired,
  handleChangeAccess: PropTypes.func.isRequired,
  callbackUpdate: PropTypes.func,
  alias: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(FileAccess);
